import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/Subscription';
import * as screenfull from 'screenfull';
import Swal from 'sweetalert2';
import { Router } from '../../../../node_modules/@angular/router';
import { AccountService } from '../../services/account.service';
import { CalendarService } from '../../services/calendar.service';
import { AuthService } from '../../services/shared/auth.service';
import { LogPublishersService } from '../../services/shared/log-publishers.service';
import { LogService } from '../../services/shared/log.service';
import { NGaugeService } from '../../services/shared/ngauge.service';
import { NotesService } from '../../services/shared/notes.service';
import { TechService } from '../../services/tech.service';
import { UserService } from '../../services/user.service';
import { IMAGE_PRE_TEXT, LOG_LEVELS, LOG_MESSAGES, USER_INFO, USER_PROPERTY } from '../../util/constants';
import { DateUtil } from '../../util/dateUtil';
import { SwitchPropertyComponent } from '../switch-property/switch-property.component';
declare let $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})

export class HeaderComponent implements OnInit, OnDestroy {

  screenfull = true;
  getUserData: any;
  getUserName: any;
  ratesSubscription: Subscription;
  @Output() toggleSidenav = new EventEmitter<void>();
  @Output() toggleNotificationSidenav = new EventEmitter<void>();
  @Output() toggleReportIssueSidenav = new EventEmitter<void>();
  @Output() toggleSuggestEnhancementSideNav = new EventEmitter<void>();
  @Output() toggleTaskSidenav = new EventEmitter<void>();
  @Output() toggleAskQuestionSideNav = new EventEmitter<void>();
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  WAITING_TIME = 1800;
  TIME_OUT = 300;
  alertMessages = [];
  propertyImageAvailable = false;
  propertyImage: any;
  profileImage: string;
  getUSerSubscription: Subscription;
  getNotesSubscription: Subscription;
  userUpdateSubscription: Subscription;
  dialogCloseSubscription: Subscription;
  propertyList = [];
  getUserProfilePicSubscriptrion: Subscription;
  timer: any;
  isMultiCluster = false;
  getReportNotSubscription: Subscription;
  refreshCountSubscription: Subscription;
  showAlert = true;

  constructor(private router: Router,
    private techService: TechService,
    private calendarService: CalendarService,
    private userService: UserService,
    private dialogRef: MatDialog,
    private http: HttpClient,
    private accountService: AccountService,
    private authService: AuthService,
    private ngaugeService: NGaugeService,
    private notesService: NotesService,
    private toastr: ToastrService,
    private idle: Idle,
    private logService: LogService,
    private keepalive: Keepalive) {
    if (sessionStorage.getItem(USER_PROPERTY) !== null) {
      this.propertyList = this.ngaugeService.isJSON(sessionStorage.getItem(USER_PROPERTY));
    }
    this.isMultiCluster = ngaugeService.checkForMultiCluster();
    // sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle(this.WAITING_TIME);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(this.TIME_OUT);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.reset();
      this.idleState = 'No longer idle.';
    });
    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      // tslint:disable-next-line: deprecation
      Swal.close();
      if (this.dialogRef !== null) {
        this.dialogRef.closeAll();
      }
      this.authService.logout();
      this.logUserActivity('Session Expired', 'Auto Sign Out');
    });
    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!';
      this.showSessionLogoutDialog();
    });
    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => {
      this.lastPing = new Date();
    });
    this.reset();
    this.userUpdateSubscription = userService.userUpdated$.subscribe(res => {
      if (res !== null) {
        this.profileImage = null;
        this.propertyImageAvailable = false;
        this.getuser();
        this.getName();
      }
    });
    function blinker() {
      $('.blink_me').fadeOut(1200);
      $('.blink_me').fadeIn(1200);
    }
    setInterval(blinker, 2000);
    this.refreshCountSubscription = this.notesService.refreshCountObs.subscribe(res => {
      if (res !== null) {
        this.getAlertNumber();
      }
    });
  }

  reset() {
    this.idle.setIdle(this.WAITING_TIME);
    this.idle.setTimeout(this.TIME_OUT);
    this.idle.watch();
    this.keepalive.interval(15);
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  getName() {
    this.getUserData = this.userService.getLoggedInUserProperty();
    this.getUserName = this.userService.getLoggedInUserName();
  }

  showSessionLogoutDialog() {
    const url = this.ngaugeService.getCurrentUrl();
    if (!url.includes('signin')) {
      const swalObject = {
        title: '<strong>Session expiring in 5 mins</strong>',
        text: 'Do you want to continue?',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      };
      const primaryContactExist = this.ngaugeService.swalOkCancelButton(swalObject);
      Swal(primaryContactExist).then(async result => {
        if (!result.value) {
          this.signOut();
          this.logUserActivity('Session Expiring, Continue?', LOG_MESSAGES.NO);
          this.logUserActivity('Session Expiring, Continue?', 'Sign Out');
        } else {
          this.logUserActivity('Session Expiring, Continue?', LOG_MESSAGES.YES);
        }
        this.reset();
      });
    }
  }

  async ngOnInit() {
    this.getName();
    await this.getuser();
    this.getAlertNumber();
    this.timer = setInterval(() => {
      this.getAlertNumber();
    }, 900000);
    this.ratesSubscription = this.accountService.getUserRates().subscribe(data => {
      if (data === 'updateUser') {
        this.getName();
        this.getuser();
      } else {
        return;
      }
    });
    const header = document.getElementById('btn');
    const btns = header.getElementsByClassName('hover-btn');
    for (let i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        const current = document.getElementsByClassName('active');
        current[0].className = current[0].className.replace(' active', '');
        this.className += ' active';
      });
    }
  }

  hamburgerClicked() {
    this.toggleSidenav.emit();
    this.logUserActivity('Left Navigation Menu - Hamburger Icon', LOG_MESSAGES.CLICK);
  }

  ngOnDestroy() {
    this.unsubscribe(this.getUserProfilePicSubscriptrion);
    this.unsubscribe(this.ratesSubscription);
    this.unsubscribe(this.getUSerSubscription);
    this.unsubscribe(this.getNotesSubscription);
    this.unsubscribe(this.userUpdateSubscription);
    this.unsubscribe(this.dialogCloseSubscription);
    this.unsubscribe(this.getUserProfilePicSubscriptrion);
    this.unsubscribe(this.getReportNotSubscription);
    this.unsubscribe(this.refreshCountSubscription);
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.screenfull = null;
    this.getUserData = null;
    this.getUserName = null;
    this.ratesSubscription = null;
    this.toggleSidenav = null;
    this.toggleNotificationSidenav = null;
    this.toggleTaskSidenav = null;
    this.idleState = null;
    this.timedOut = null;
    this.propertyList = null;
    this.lastPing = null;
    // this.WAITING_TIME = null;
    // this.TIME_OUT = null;
    this.http = null;
    this.alertMessages = null;
    this.propertyImageAvailable = null;
    this.propertyImage = null;
    this.profileImage = null;
    this.router = null;
    this.calendarService = null;
    this.userService = null;
    this.dialogRef = null;
    this.accountService = null;
    this.authService = null;
    this.notesService = null;
    this.techService = null;
    // this.idle = null;
    // this.keepalive = null;
    this.timer = null;
    this.isMultiCluster = null;
    this.showAlert = null;
  }

  unsubscribe(subscription: Subscription) {
    if (this.ngaugeService.checkForNllUndef(subscription)) {
      subscription.unsubscribe();
    }
  }

  getAlertNumber() {
    this.alertMessages = [];
    const todaysDate = DateUtil.getFormattedDate(new Date());
    this.getNotesSubscription = this.notesService.getNotes(todaysDate).subscribe(getNotes => {
      const userId = this.userService.getLoggedInUserId();
      this.getReportNotSubscription = this.notesService.getReportNotification(userId).subscribe((response: any) => {
        const messages = getNotes['result'].concat(response);
        this.alertMessages = messages.filter(res => res.status === 'notread');
        const errorMessage = `You have ${this.alertMessages.length} notifications`;
        if (this.alertMessages.length > 0 && this.showAlert === true) {
          this.showAlert = false;
          if (this.alertMessages.length < 50) {
            this.toastr.warning('Please check the notification', errorMessage);
          } else {
            this.toastr.error('Please check the notification', errorMessage);
          }
        }
      }, error => {
        this.logService.logError(LOG_LEVELS.ERROR, 'Header Component', 'On Fetch Report Notification', JSON.stringify(error));
      });
    }, error => {
      this.logService.logError(LOG_LEVELS.ERROR, 'Header Component', 'On Fetch Notes', JSON.stringify(error));
    });
  }

  getuser() {
    return new Promise(resolve => {
      const user = this.userService.getSessionStorage();
      this.propertyImage = IMAGE_PRE_TEXT + user['propertyLogo'];
      this.propertyImageAvailable = this.ngaugeService.checkForNllUndef(user['propertyLogo']) ? true : false;
      this.getUserProfilePicSubscriptrion = this.authService.getUserProfilePic(user['id']).subscribe(res => {
        user['profileImage'] = res['image'];
        if (user['profileImage'] !== null && user['profileImage'] !== '') {
          this.profileImage = atob(user['profileImage']);
        }
        sessionStorage.setItem(USER_INFO, JSON.stringify(user));
        const logConfig = new LogPublishersService(this.http, this.logService, this.ngaugeService);
        logConfig.buildPublishers();
        resolve(true);
      }, error => {
        console.log('ERROR getUser 298', error)
        resolve(true);
        this.logService.logError(LOG_LEVELS.ERROR, 'Header Component', 'On Fetch User Profile Pic', JSON.stringify(error));
      });
    });
  }

  toggle() {
    this.accountService.setUserRates('notificationEvent');
    this.calendarService.broadcast('notificationEvent', 'some message');
    this.logUserActivity('Notification', LOG_MESSAGES.CLICK);
  }

  reportIssueToggle() {
    this.logUserActivity('Report Issue', LOG_MESSAGES.CLICK);
  }

  suggestEnhancementToggle() {
    this.logUserActivity('Suggest Enhancement', LOG_MESSAGES.CLICK);
  }

  askQuestionToggle() {
    this.logUserActivity('Ask Question', LOG_MESSAGES.CLICK);
  }

  fullScreenToggle(): void {
    this.screenfull = screenfull.isFullscreen === false ? false : true;
    screenfull.toggle();
    this.logUserActivity('Full Screen Mode', LOG_MESSAGES.TOGGLE);
  }

  removeTokens() {
    localStorage.removeItem('Id');
    sessionStorage.removeItem('Id');
  }

  editProfile() {
    this.techService.publishCloseSideNavTriggerer('close');
    const userId = this.userService.getLoggedInUserId();
    const navigationExtras = {
      queryParams: { userId }
    };
    this.router.navigate(['/users/edit'], navigationExtras);
    this.logUserActivity('Profile Picture Menu', 'Edit Profile');
  }

  signOut() {
    this.logUserActivity('Profile Picture Menu', 'Sign Out');
    this.authService.logout();
  }

  switchProperty() {
    this.techService.publishCloseSideNavTriggerer('close');
    const dialog = this.dialogRef.open(SwitchPropertyComponent, {
      width: '500px',
      data: { propertyList: this.propertyList, accept: 'Switch!', reject: 'Cancel' }
    });
    this.dialogCloseSubscription = dialog.afterClosed().subscribe(() => { console.log('Switch property Done'); });
    this.logUserActivity('Profile Picture Menu', 'Switch Property');
  }

  profilePicClicked() {
    this.logUserActivity('Profile Picture Menu', 'Click');
  }

  logUserActivity(from, value) {
    this.logService.logUserActivity(LOG_LEVELS.INFO, from, value);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/header/header.component.ts